import type { ButtonHTMLAttributes } from 'react'
import { cx } from './cx'
import { Icon, type IconName } from './Icon'
import styles from './IconButton.module.css'

interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: IconName
  /** Required: icon-only controls need an accessible name. Also used as the tooltip. */
  'aria-label': string
  size?: number
}

/** Row action (edit, delete, link_off): transparent, padding 4, 17px tertiary icon. */
export function IconButton({
  icon,
  size = 17,
  className,
  type = 'button',
  'aria-label': ariaLabel,
  ...rest
}: IconButtonProps) {
  return (
    <button
      {...rest}
      type={type}
      aria-label={ariaLabel}
      title={ariaLabel}
      className={cx(styles.button, className)}
    >
      <Icon name={icon} size={size} />
    </button>
  )
}
